import { Grid } from "@material-ui/core";
import HeaderModal from "../../../../global/headerModal";
import ModalBase from "./../../../../global/ModalBase";
import { makeStyles } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { modalDetalleExtraAction } from "../../../../ducks/cotizadorPaqueteDuck";
import { useEffect, useState } from "react";

export const MDatalleExtraStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 0",
        padding: "1rem",
        overflowY: "scroll",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "400px",
        maxWidth: "600px",
        minHeight: "400px"
    },
}));
const useExtra = ({ idExtra }) => {
    const [extra, setExtra] = useState({})
    const { listaItems } = useSelector(store => store.cotizadorPaquete)
    useEffect(() => {
        const busqueda = () => {
            const extra = listaItems.find(val => val.id === idExtra)
            if (extra)
                setExtra(extra)
        }
        if (idExtra !== "0")
            busqueda()
    }, [idExtra, listaItems])
    return {extra}
}
export const MDetalleExtra = () => {
    const { modalDetalleExtra, modalTargetExtra } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    const classes = MDatalleExtraStyle();
    const {extra} = useExtra({idExtra: `${modalTargetExtra}`})
    const handleClose = () => {
        dispatch(modalDetalleExtraAction({ open: false, idExtra: "0" }))
    }
    return (
        <ModalBase classes={classes} open={modalDetalleExtra} onClose={handleClose}>
            <HeaderModal handleClose={handleClose} titulo={`Detalle extra`} />
            <Grid container className={classes.containerSpacing}>
                <h4>{`${extra?.name}`}</h4>
                <div dangerouslySetInnerHTML={{ __html: `${extra?.description}` }} />
            </Grid>
        </ModalBase>
    )
}
export default MDetalleExtra